const READ_KEY = 'bookscape_notif_read';
export const NOTIFICATION_READ_EVENT = 'bookscape:notifications-read-changed';
const PROMOTIONAL_TYPES = new Set(['offer', 'promotion', 'promotional']);

const getReadSet = () => {
  try {
    const raw = localStorage.getItem(READ_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    return new Set(Array.isArray(arr) ? arr : []);
  } catch {
    return new Set();
  }
};

const saveReadSet = (set) => {
  try {
    localStorage.setItem(READ_KEY, JSON.stringify(Array.from(set)));
  } catch {
    /* ignore */
  }
};

const statusMessage = (status) => {
  if (status === 'shipped') return 'Your order has been shipped and is on its way.';
  if (status === 'delivered') return 'Your order has been delivered. Enjoy your purchase!';
  if (status === 'cancelled') return 'Your order has been cancelled.';
  return `Order status updated to ${status}.`;
};

const buildNotificationsFromOrders = (orders) => {
  const list = [];
  (orders || []).forEach((o) => {
    const orderId = o.orderId || o.id;
    if (!orderId) return;
    const baseDate = o.updatedAt || o.createdAt || o.date || new Date().toISOString();
    const status = (o.rawStatus || o.status || '').toLowerCase();
    const paymentStatus = (o.paymentStatus || '').toLowerCase();

    list.push({
      id: `order-${orderId}-placed`,
      orderId,
      type: 'order_placed',
      title: `Order #${orderId} placed`,
      message: `Your order has been received and is being processed.`,
      date: o.createdAt || o.date || baseDate,
      link: `/profile?tab=orders&order=${encodeURIComponent(orderId)}`,
      linkText: 'View Order',
    });

    if (status && status !== 'pending' && status !== 'processing') {
      list.push({
        id: `order-${orderId}-status-${status}`,
        orderId,
        type: `order_${status}`,
        title: `Order #${orderId} ${status}`,
        message: statusMessage(status),
        date: baseDate,
        link: `/profile?tab=orders&order=${encodeURIComponent(orderId)}`,
        linkText: status === 'shipped' ? 'Track Order' : 'View Order',
      });
    }

    if (paymentStatus === 'paid') {
      list.push({
        id: `order-${orderId}-paid`,
        orderId,
        type: 'payment_received',
        title: `Payment confirmed for #${orderId}`,
        message: `Payment of ${o.totalAmount ?? o.total ?? ''} received successfully.`,
        date: baseDate,
        link: `/profile?tab=orders&order=${encodeURIComponent(orderId)}`,
        linkText: 'View Order',
      });
    }
  });

  return list.sort((a, b) => new Date(b.date) - new Date(a.date));
};

export const getNotifications = (orders) => {
  const all = buildNotificationsFromOrders(orders).filter(({ type }) =>
    PROMOTIONAL_TYPES.has(type)
  );
  const readSet = getReadSet();
  return all.map((n) => ({ ...n, read: readSet.has(n.id) }));
};

export const getUnreadCount = (orders) => {
  const readSet = getReadSet();
  return buildNotificationsFromOrders(orders).filter(
    (notification) =>
      PROMOTIONAL_TYPES.has(notification.type) && !readSet.has(notification.id)
  ).length;
};

export const markAsRead = (id) => {
  const set = getReadSet();
  set.add(id);
  saveReadSet(set);
};

export const markAllAsRead = (orders) => {
  const set = getReadSet();
  buildNotificationsFromOrders(orders)
    .filter(({ type }) => PROMOTIONAL_TYPES.has(type))
    .forEach((n) => set.add(n.id));
  saveReadSet(set);
};

export const clearReadState = () => {
  localStorage.removeItem(READ_KEY);
};
